import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { Loader } from "arv-reactcomponents";

import { returnAnchorWithId } from "../../utils";

@inject("StaticPageStore")
@observer
class StaticPageContent extends Component {
  constructor(props) {
    super(props);

    this.fetchDescription = this.fetchDescription.bind(this);
    this.setClassName = this.setClassName.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
    this.scrollToView = this.scrollToView.bind(this);
  }

  componentDidMount() {
    this.fetchDescription();
  }

  fetchDescription() {
    switch (this.props.fetchDescription) {
      case "whoweare":
        this.props.StaticPageStore.fetchWhoWeAreDescription().then(response => {
          this.handleResponse(response);
        });
        break;
      case "customercare":
        this.props.StaticPageStore.fetchCustomerCareDescription().then(
          response => {
            this.handleResponse(response);
          },
        );
        break;
      case "termsandcondition":
        this.props.StaticPageStore.fetchTermsAndConditionDescription().then(
          response => {
            this.handleResponse(response);
          },
        );
        break;
      case "privacypolicy":
        this.props.StaticPageStore.fetchPrivacyPolicyDescription().then(
          response => {
            this.handleResponse(response);
          },
        );
        break;
      default:
        console.log(this.description);
        break;
    }
  }

  handleResponse(response) {
    if (response) {
      this.setClassName(response);
    }
  }

  setClassName(content) {
    if (content && content.length) {
      try {
        const element = document.getElementById("nw-staticpagecontent");
        element.innerHTML = content;
        const anchors = element.querySelectorAll("a");
        anchors.forEach(item => {
          if (item.id.length) {
            item.className += "nw-staticpagecontent-anchors";
          }
        });
        this.scrollToView();
      } catch (error) {
        console.log(error);
      }
    }
  }

  scrollToView() {
    console.log(this.props);
    const value = window.location.hash;
    if (value && value.length) {
      const container = document.getElementsByClassName(
        "nw-staticpagecontent-anchors",
      );
      const element = returnAnchorWithId(value.replace("#", ""), container);
      if (element) {
        element.scrollIntoView();
      } else {
        window.scrollTo(0, 0);
      }
    }
  }

  get returnDescription() {
    switch (this.props.fetchDescription) {
      case "whoweare":
        return this.props.StaticPageStore.whoWeAreDescription;
      case "customercare":
        return this.props.StaticPageStore.customerCareDescription;
      case "termsandcondition":
        return this.props.StaticPageStore.termsAndConditionDescription;
      case "privacypolicy":
        return this.props.StaticPageStore.privacyPolicyDescription;
      default:
        return " ";
    }
  }

  render() {
    let description = " ";

    description = this.returnDescription;

    return description && description.length > 1 ? (
      <div id="nw-staticpagecontent" />
    ) : (
      <Loader className="nw-staticpagecontent-loader" />
    );
  }
}

StaticPageContent.propTypes = {
  fetchDescription: PropTypes.string.isRequired,
  StaticPageStore: PropTypes.shape({
    fetchWhoWeAreDescription: PropTypes.func.isRequired,
    fetchCustomerCareDescription: PropTypes.func.isRequired,
    fetchTermsAndConditionDescription: PropTypes.func.isRequired,
    fetchPrivacyPolicyDescription: PropTypes.func.isRequired,
    whoWeAreDescription: PropTypes.shape({}),
    customerCareDescription: PropTypes.shape({}),
    termsAndConditionDescription: PropTypes.shape({}),
    privacyPolicyDescription: PropTypes.shape({}),
  }).isRequired,
};

const getFinalComponent = component =>
  inject("StaticPageStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: StaticPageContent.wrappedComponent,
  component: StaticPageContent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StaticPageContent/index.js